import styled from "styled-components";
import ThemeColors from "../../../../../../themes/colors";

export const MainContainer = styled.div`
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  overflow: auto;
`;

export const Item = styled.div`
  display: flex;
  gap: 0.25rem;
  align-items: flex-start;
  transition: background-color ease 0.2s;
  padding: 0.25rem;
  border-radius: 0.5rem;

  &:hover {
    background-color: ${ThemeColors.Black50};
  }
`;

export const Triangle = styled.div`
  width: 0;
  height: 0;
  border-left: 0.577rem solid transparent;
  border-right: 0.577rem solid transparent;
  border-bottom: 1rem solid #8863ff;
  clip-path: polygon(50% 0%, 100% 100%, 0% 100%);
  border-radius: 0.2rem;
`;

export const Square = styled.div`
  width: 1rem;
  height: 1rem;
  background-color: #6ede7b;
  border-radius: 0.2rem;
`;

export const Circle = styled.div`
  width: 1rem;
  height: 1rem;
  background-color: #40acff;
  border-radius: 50%;
`;
